import { Star } from "lucide-react";

import { cn } from "../../lib/utils";
import SectionHeading from "../../components/common/SectionHeading";

type Testimonial = {
  quote: string;
  name: string;
  role: string;
  rating: number;
};

const testimonials: Testimonial[] = [


  {
    quote:
      "«I own a paver shop. MrJoe.pro saves time, boosts productivity, and lets me send professional estimates and invoices instantly while showcasing my work. Great experience!»",
    rating: 5,
    name: "Geo Dos Santos",
    role: "Paver Installation, Pasco County, FL",
  },


  {
    quote:
      "«With MrJoe.pro I no longer waste time doing a lot of estimates. I use their amazing AI powered estimates that makes my life much easier, and send estimates to customers quickly.»",
    rating: 5,
    name: "Sarah Thompson",
    role: "Electrical Contractor, Orlando, FL",
  },
  {
    quote:
      "«MrJoe.pro helps me run my plumbing much easier. I can track projects, send estimates and invoices, and keep everything in one place. Highly recommend!»",
    rating: 5,
    name: "Mike Rodriguez",
    role: "Plumbing Services, Dallas, TX",
  }
];

export default function TestimonialsSection() {
  return (
    <section className="bg-page-gray-soft section-padding">
      <div className="container-safe">
        <SectionHeading title="Trusted by Businesses Across the US" />

        <ul className="xs:mt-10 mt-6 grid grid-cols-1 gap-3 md:mt-14 md:grid-cols-3 md:gap-4 lg:gap-8">
          {testimonials.map((t, i) => {
            const isFirst = i === 0;
            const isLast = i === testimonials.length - 1;

            return (
              <li
                key={i}
                className={cn(
                  "relative overflow-visible",
                  isFirst && "quote-start",
                  isLast && "quote-end"
                )}
              >
                <div className="bg-background shadow-card hover:shadow-card-hover relative z-10 rounded-2xl px-7 py-8 transition-shadow">
                  {/* Rating */}
                  <div className="text-primary flex items-center gap-1">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <Star
                        key={index}
                        className={`size-6 ${index < t.rating ? "fill-current" : ""}`}
                      />
                    ))}
                  </div>

                  <blockquote className="mt-3 text-sm leading-6">{t.quote}</blockquote>

                  {/* Author */}
                  <div className="mt-3 flex items-center gap-4">


                    <div>
                      <div>{t.name}</div>
                      <div className="text-paragraph mt-0.5 text-sm">{t.role}</div>
                    </div>
                  </div>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
